<template>
  <div class="row">
    <div class="col-md-1"></div>
    <div class="col-md-10">
      <div class="row dashboard-border">
        <div class="col-md-3 col-7 align-self-center" >
          <img src="../../assets/icons/projects.png" height="32" width="32"/>
          <span class="mx-2"> Segment List</span>
        </div>
        <div class="col-md-9 col-5 text-end align-self-center">
          <button @click="AddSegmentNew()" class="btn" type="button" style="background-color: #56759c;color:#ffffff" >
            <font-awesome-icon icon="plus-circle" /><span style="color: #ffffff;font-weight: unset" class="mx-1"> New Segment</span>
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-md-9">
          <div v-if="!isLoading" class="row modified-table mt-3 table-responsive">
            <dynamic-table :gridconfig="gridconfig" :gridData="segments" :gridMainConfig="gridMainConfig" @dynamic-button="TryUpdateProject"></dynamic-table>
          </div>
          <div v-else>
            <LoadingButton/>
          </div>
        </div>
        <div class="col-md-3 mt-3">
          <ldap-side-form :segment-form="this.segmentInfoForm" :modal-form="this.modalInfoForm" :systems="this.systems" :segment-info-form="this.segmentInfoForm"> </ldap-side-form>
        </div>
      </div>
    </div>
    <div class="col-md-1"></div>
  </div>

</template>

<script>

    import {createNamespacedHelpers} from 'vuex';
    import {loadingMixin} from "../../utils/mixins";
    import LoadingButton from "../../components/ui/LoadingButton";
    import LdapSideForm from "../../components/ui/LdapSideForm";
    import DynamicTable from "../../components/ui/DynamicTable";
    const {mapActions, mapState} = createNamespacedHelpers('ldapsync');

    export default {
        name: "LdapSync",
        mixins: [loadingMixin],
        components: {
            LoadingButton,
            LdapSideForm,
            DynamicTable
        },
        data() {
            return {
                /**columns: [
                  {name: 'id', type: 'int'}
                  , {name: 'Syst.Id', type: 'int'}
                  , {name: 'Segment Name', type: 'string'}
                  , {name: 'System', type: 'string'}
                  , {name: 'Test Mail', type: 'string'}
                  , {name: 'Test Mail Password', type: 'string'}
                  , {name: 'Last Sync Date', type: 'datetime'}
                ],**/
                gridconfig:[
                  {fieldName :'id',fieldTitle:'Id' , type : 'text', icon:'', format:''},
                  {fieldName :'segmentName',fieldTitle:'Segment Name' , type : 'text',icon:'' , format:''},
                  {fieldName :'system',fieldTitle:'System' , type : 'text',icon:'' , format:''},
                  {fieldName :'syncMail',fieldTitle:'Test Mail' , type : 'text' ,icon:'' , format:''},
                  {fieldName :'syncMailPassword',fieldTitle:'Test Mail Password' , type : 'password',icon:'' , format:''},
                  {fieldName :'lastSyncDT',fieldTitle:'Update Date' , type : 'datetime' , icon:'' ,format:"shortFormatDateNumeric"}
                ],
                gridMainConfig: {
                  pagination:false,sorting:true
                },
                isActiveSyncDataList: false,
                segmentInfoForm: {
                    id: 0,
                    systemId: 0,
                    segmentName: "",
                    system: "",
                    syncMail: "",
                    syncMailPassword: "",
                },
                modalInfoForm:{
                  isActiveModal: false,
                  isEmptyDiv: true,
                }
            }
        },
        methods: {
            ...mapActions(["getSegments","getSegment", "getSystems","openCloseSyncModal","AddSegment"]),
            async TryGetSegments() {
                this.showLoading();
                try {
                    this.getSegments();
                } catch (e) {
                    this.$notify({title: "Error", type: "error", text: e.message});
                } finally {
                    this.hideLoading();
                }
            },
            async AddSegmentNew(){
              let scrollForm = document.querySelector('.segmentForm');
              scrollForm.scrollIntoView(true);
              this.segmentInfoForm.id = null;
              this.segmentInfoForm.systemId = null;
              this.segmentInfoForm.segmentName = "";
              this.segmentInfoForm.system = "";
              this.segmentInfoForm.syncMail = "";
              this.segmentInfoForm.syncMailPassword = "";
              this.modalInfoForm.isEmptyDiv = false;
              this.modalInfoForm.isActiveModal = true;
            },
            async TryUpdateProject(value) {
              let scrollForm = document.querySelector('.segmentForm');
              scrollForm.scrollIntoView(true);
              this.modalInfoForm.isEmptyDiv = false;
              this.modalInfoForm.isActiveModal = true;
              try {
                await this.getSegment(value.id);
                this.segmentInfoForm.id = value.id;
                this.segmentInfoForm.systemId = value.systemId;
                this.segmentInfoForm.segmentName = value.segmentName;
                this.segmentInfoForm.system = value.system;
                this.segmentInfoForm.syncMail = value.syncMail;
                this.segmentInfoForm.syncMailPassword = value.syncMailPassword;
              } catch (e) {
                this.$notify({title: "Error", type: "error", text: e.message});

              }
            },
            async closeLdapListModal() {
                this.isActiveSyncDataList = false;
            }

        },
        computed: {
            ...mapState(["segments", "segment", "systems", "isActiveModal","ldapUsers"]),
        },
        created() {
            this.TryGetSegments();
            this.getSystems();
        },
        mounted() {
            document.body.addEventListener('keyup', e => {
                if (e.keyCode === 27)//ESC
                {
                    this.openCloseSyncModal();
                }
            })
        },


    }
</script>

<style scoped>
    .table-font{
      font-size: 13px;
      font-family: Helvetica, Arial;
      border-left: 1px solid #dfe0e1;
    }
    .hidetext {
      -webkit-text-security: disc;
    }
</style>
